import { SxProps, Theme } from '@mui/material';

export type SkeletonFieldType = 'text' | 'textarea';

export const SKELETON_ANIMATION = 'pulse' as const;
export const SKELETON_RADIUS = 'sm' as const;

export type SkeletonBaseProps = {
    sx?: SxProps<Theme>;
};

export type SkeletonTextProps = SkeletonBaseProps & {
    width?: string | number;
    height?: number;
};

export type SkeletonBoxProps = SkeletonBaseProps & {
    width?: string | number;
    height?: string | number;
};

export type SkeletonCircleProps = SkeletonBaseProps & {
    size?: number;
};

export type SkeletonFieldProps = SkeletonBaseProps & {
    type?: SkeletonFieldType;
    width?: string | number;
};

export type TableSkeletonProps = SkeletonBaseProps & {
    rows?: number;
    columns?: number;
};

export type FormSkeletonProps = SkeletonBaseProps & {
    hasActions?: boolean;
};

export type ParagraphSkeletonProps = SkeletonBaseProps;

export type SessionSkeletonProps = SkeletonBaseProps;

export type CardSkeletonProps = SkeletonBaseProps;

export type RowSkeletonProps = SkeletonBaseProps & {
    avatar?: boolean;
    actions?: boolean;
};

export type ClientSkeletonProps = SkeletonBaseProps;

type ListSkeletonClientProps = SkeletonBaseProps & {
    client: true;
};

type ListSkeletonRowProps = SkeletonBaseProps & {
    client?: false;
    avatar?: boolean;
    actions?: boolean;
};

export type ListSkeletonProps = ListSkeletonClientProps | ListSkeletonRowProps;

export const SKELETON_INPUT_HEIGHT = 24;
export const SKELETON_TEXT_HEIGHT = 16;
export const SKELETON_BUTTON_HEIGHT = 36;
export const SKELETON_BUTTON_WIDTH = 128;
